var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 29,
  height: 64,
  viewBox: "0 0 29 64",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.25 64V35.556H0V24.889h7.25V13.176C7.25 4.54 9.554 0 19.35 0H29v10.667h-7.25c-3.813 0-3.625 4.35-3.625 7.11v7.112h10.013l-1.655 10.667h-8.358V64z"
})));
export default SvgChannelFacebook;